import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-close\"><path d=\"M633.423257 512.225211L998.360663 147.293802A86.022145 86.022145 0 1 0 876.712195 25.639337L511.774789 390.586739 146.835384 25.639337A86.018147 86.018147 0 0 0 25.188915 147.287805L390.128321 512.225211 25.188915 877.158619A86.020146 86.020146 0 0 0 146.835384 998.811085L511.774789 633.865682 876.712195 998.811085a86.020146 86.020146 0 0 0 121.648468-121.652466z\" p-id=\"32919\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol